var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("CorporateNavigation", { attrs: { ActivePage: "dashboard" } }),
      _vm._v(" "),
      _vm.rm
        ? _c(
            "div",
            {
              staticClass: "container-fluid",
              staticStyle: { "margin-top": "80px", "padding-top": "20px" },
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-6" }, [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v("Enterprise Plan: " + _vm._s(_vm.rm.ScenarioName)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "h1",
                    {
                      staticStyle: {
                        "font-size": "2em",
                        "font-weight": "300",
                        color: "#33475b",
                        margin: "0",
                      },
                    },
                    [_vm._v("Schedule")]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-lg-6 d-flex flex-column justify-content-end",
                  },
                  [_c("ScenarioNavigation")],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c(
                "nav",
                {
                  staticClass: "mt-5 navbar navbar-light navbar-expand-md",
                  staticStyle: {
                    "background-color": "rgba(0, 0, 0, 0.03)",
                    border: "1px solid rgba(0, 0, 0, 0.125)",
                    "border-bottom": "0",
                  },
                  attrs: { role: "navigation" },
                },
                [
                  _c(
                    "form",
                    {
                      staticClass: "form-inline my-2 my-lg-0 ml-auto",
                      attrs: { role: "search" },
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.searchPhrase,
                            expression: "searchPhrase",
                          },
                        ],
                        staticClass: "form-control mr-sm-2",
                        attrs: { type: "search", placeholder: "Search" },
                        domProps: { value: _vm.searchPhrase },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.searchPhrase = $event.target.value
                          },
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { height: "calc(100vh - 300px)" } },
                [
                  _c(
                    "gantt",
                    {
                      attrs: {
                        "data-source": _vm.dataSource,
                        "tooltip-template": "xxx",
                        editable: false,
                        height: "100%",
                      },
                      on: { change: _vm.edit },
                    },
                    [
                      _c("gantt-view", {
                        attrs: { type: "year", selected: true },
                      }),
                      _vm._v(" "),
                      _c("gantt-column", {
                        attrs: {
                          field: "title",
                          title: "Name",
                          sortable: true,
                        },
                      }),
                      _vm._v(" "),
                      _c("gantt-column", {
                        attrs: {
                          field: "start",
                          title: "Start",
                          format: "{0:MM/yyyy}",
                          sortable: true,
                          width: 120,
                        },
                      }),
                      _vm._v(" "),
                      _c("gantt-column", {
                        attrs: {
                          field: "end",
                          title: "End",
                          format: "{0:MM/yyyy}",
                          sortable: true,
                          width: 120,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }